import { defineMessages } from 'react-intl-next';

export const i18n: {
	confluenceFilterLabelPlaceholder: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	confluenceFilterLabelSelected: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	confluenceFilterLabelsNoText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	label: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	label: {
		id: 'dynamic-cards-search-page.filters.names.labels',
		defaultMessage: 'Label',
		description:
			'Label for label filter dropdown shown in search page filters where user can select label to filter search result by label',
	},
	confluenceFilterLabelPlaceholder: {
		id: 'dynamic-cards-search-page.confluence.filter.labels.placeholder',
		defaultMessage: 'Find labels',
		description: 'Placeholder for label filter search input',
	},
	confluenceFilterLabelSelected: {
		id: 'dynamic-cards-search-page.confluence.filter.label.selected',
		defaultMessage: 'Selected',
		description: 'Confluence filter label selected',
	},
	confluenceFilterLabelsNoText: {
		id: 'dynamic-cards-search-page.advanced-search.labels.filter.no.text',
		defaultMessage: 'Start typing to search for a label',
		description: "Text displayed when the user hasn't begun typing a label",
	},
});
